/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Fleet_TypeInputs */

const en_clients_field_fleet_type = /** @type {(inputs: Clients_Field_Fleet_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fleet type`)
};

const pt_br2_clients_field_fleet_type = /** @type {(inputs: Clients_Field_Fleet_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de frota`)
};

/**
* | output |
* | --- |
* | "Fleet type" |
*
* @param {Clients_Field_Fleet_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_fleet_type = /** @type {((inputs?: Clients_Field_Fleet_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Fleet_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_fleet_type(inputs)
	return pt_br2_clients_field_fleet_type(inputs)
});